<template>
    <div id="contenedor-principal-edictos">
        <div v-if="this.campoRequeridoEsValido(datosArea)" id="titulo-area">
            <h1>{{ datosArea.titulo }}</h1>
            <h3>{{ datosArea.subtitulo }}</h3>
            <div class="hr-titulo"></div>
        </div>
        <CSeccion v-for="(seccion) in secciones" :key="'seccion-' + seccion.SeccionId" 
            class="espacio-entre-secciones"
            v-on:enviarEdicto="enviarEdicto"
            :informacion="{ idElemento: seccion.SeccionId, nombre: seccion.Nombre }"
            :formatosDeSeccion="[{ tipoDeFormato: seccion.FormatoId, contenidos: seccion.Contenidos }]"
            :opciones="{ tiposDocumentoArea: tiposDocumentosArea }"></CSeccion>
        <!-- MODAL INFORMATIVO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo-edictos">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-body pl-4 pr-4 pt-4 pb-4">
                        <div class="text-center">
                            <i class="far fa-check-circle"></i>
                            <h3>Enviado</h3>
                            <h6>El edicto se ha sido enviado de manera exitosa</h6>
                            <button class="btn btn-primary" @click="cerrarModalInformativo">Ok</button>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import router from '@/router/index'
import CSeccion from "@/components/Intranet/Comun/CSeccion.vue";
import comun from "@/../static/js/comun"

export default {
    components: {
        CSeccion: CSeccion
    },
    beforeRouteEnter (to, from, next) {
        const VISTA_RAIZ = 'Inicio';
        next(async (instanciaVue) => {
            instanciaVue.cargandoInformacion = true;
            const PAGINA_HABILITADA = await Promise.resolve(instanciaVue.usuarioTieneLaPaginaHabilitada({ ruta: to.path }));
            if(!PAGINA_HABILITADA) {
                router.push({ name: VISTA_RAIZ});
                instanciaVue.cargandoInformacion = false;
                comun.mensajeDeAlerta('No tienes acceso a la pagina solicitada', null, null);
            }
        });
    },
    data() {
        return {
            secciones: [],
            datosArea: {  titulo: 'Envío de Edictos', subtitulo: 'Acceso solo para personal autorizado.' },
            tiposDocumentosArea: []
        }
    },
    methods: {
        usuarioTieneLaPaginaHabilitada: async function({ ruta }) {
            let habilitada = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.VerificarSiTieneHabilitadaPagina;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDePagina: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: ruta })
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, TieneHabilitadaLaPagina } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    habilitada = TieneHabilitadaLaPagina
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return habilitada;
        },
        enviarEdicto: function(datos) {
            $('#modal-informativo-edictos').modal("show");
        },
        cerrarModalInformativo: function() {
            $('#modal-informativo-edictos').modal("hide");
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    created() {
        // buscar en bd las secciones del area
        this.secciones = [
            { SeccionId: 5, Nombre: 'Formulario envio de edictos', FormatoId: 38, Contenidos: [] }
        ];
        $('html, body').animate({ scrollTop:0 }, 'slow');
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
        }
    }
}
</script>
<style scoped>
#modal-informativo-edictos .modal-lg {
    max-width: 35% !important;
    z-index: 9999999999999999999999999999999999999;
}

#modal-informativo-edictos .modal-content {
    background-color: #FFFFFF;
    box-shadow: 0px 6px 20px 8px #424242;;
}

#modal-informativo-edictos .modal-header {
    background-color: rgb(36, 34, 34);
    border: none;
}

#modal-informativo-edictos .modal-dialog {
  position: relative;
  top: 40%;
  transform: translateY(-50%);
}

#modal-informativo-edictos i {
    color: #676666;
    font-size: 5em;
    margin-bottom: 0.3em;
}

#modal-informativo-edictos h3 {
    color: #676666;
    font-size: 2.4em;
    font-weight: bold;
    margin-bottom: -1px;
}

#modal-informativo-edictos h6 {
    color: #A08F8F;
    font-size: 1.4em;
    margin-bottom: 1.5em;
}

#modal-informativo-edictos .btn-primary {
    background-color: #50A728;
}

.espacio-entre-secciones {
    margin-top: 3vmin;
}

#contenedor-principal-edictos {
    padding: 7vmin 16vmin 10vmin 16vmin;
}

#titulo-area h1 {
    font-size: 5vmin;
    font-weight: bold;
    color: #000000;
    margin-bottom: -0.1em;
}

#titulo-area h3 {
    font-size: 2.5vmin;
    color: #AF9C9C;
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#be9a5e;
}

</style>


// WEBPACK FOOTER //
// src/components/Intranet/Areas/Edictos/CEdictos.vue